export default __webpack_public_path__ + "static/media/hero-4.dfde9e72.jpg";